import(/* webpackMode: "eager" */ "/opt/hotlistcasino/frontend/src/app/error.tsx");
